import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/company/employees/page.tsx");
